var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-checkbox",on:{"click":function($event){$event.stopPropagation();return _vm.setChecked.apply(null, arguments)}}},[(_vm.checked)?_c('img',{attrs:{"src":("/img/" + _vm.icon + ".svg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }